"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WindowService = (function () {
    function WindowService() {
    }
    WindowService.pushToDatalayer = function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    };
    return WindowService;
}());
exports.default = WindowService;
//# sourceMappingURL=WindowService.js.map